import { useState, useEffect } from 'react'
import { useAccount, useDisconnect } from 'wagmi'

import Dialog from '@mui/material/Dialog'
import { Typography } from 'primsell-shared-layer/components'
import Box from '@mui/material/Box'

import { Button } from 'primsell-shared-layer/components'

import { useStyles } from './sub-sign-mobile-dialog.styles'

export interface ISignMobileDialogsProps {
  isSigning: boolean
  isLoading: boolean
  data: string | undefined
  handleSign: () => void
}

const SubSignMobileDialog = ({ isSigning, isLoading, data, handleSign }: ISignMobileDialogsProps): JSX.Element => {
  const { classes } = useStyles()

  const { disconnect } = useDisconnect()
  const { isConnected } = useAccount()

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isConnected && !isSigning && !data) {
      setIsOpen(true)
    }
  }, [isConnected, isSigning, data])

  useEffect(() => {
    if (data) {
      setIsOpen(false)
    }
  }, [data])

  const onCancel = () => {
    disconnect()
    setIsOpen(false)
  }

  return (
    <Dialog
      PaperProps={{
        classes: {
          root: classes.dialogPaperRoot,
        },
      }}
      open={isOpen}
      fullScreen
      onClose={onCancel}
    >
      <Box className={classes.dialogSign}>
        <Box className={classes.dialogSignText}>
          <Typography className={classes.dialogSignTextTitle}>Are you sure?</Typography>
          <Typography className={classes.dialogSignTextDescription}>
            You will be redirected to your external wallet to approve operation. Do you want to continue?
          </Typography>
        </Box>
        <Box className={classes.dialogSignBtns}>
          <Button color="dark" variant="filled" fullWidth disabled={isLoading} onClick={handleSign}>
            Continue with wallet
          </Button>
          <Button color="grey" variant="outlined" fullWidth disabled={isLoading}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export { SubSignMobileDialog }
